import React, { ReactNode } from "react";

import cn from "classnames";

import OverlayView from "@app/component/map/core/primitives/OverlayView";
import useMap from "@app/component/map/FeaturedMap/context/useMap";
import { BASE_TOOLTIP_ZINDEX } from "@app/util/map/consts";

import styles from "./MapTooltip.module.scss";

interface Props {
  // "top" anchors the tooltip's bottom edge above the position so taller (multi-line) tooltips
  // clear the marker instead of overlapping it. Default keeps the legacy fixed upward offset.
  placement?: "top";
  position?: google.maps.LatLng | google.maps.LatLngLiteral;
  showArrow?: boolean;
  tooltip?: ReactNode;
  // Stacking order within the tooltip pane; raise above BASE_TOOLTIP_ZINDEX to sit over other tooltips.
  zIndex?: number;
}

const MapTooltip = ({
  placement,
  position,
  showArrow = true,
  tooltip,
  zIndex = BASE_TOOLTIP_ZINDEX,
}: Props) => {
  const { map } = useMap();

  const isVisible = map && position && tooltip;

  return isVisible ? (
    <OverlayView map={map} pane="markerLayer" position={position} zIndex={zIndex}>
      <div className={cn(styles.container, { [styles.placementTop]: placement === "top" })}>
        {showArrow && <div className={styles.arrow} />}
        <div className={styles.text}>{tooltip}</div>
      </div>
    </OverlayView>
  ) : null;
};

export default MapTooltip;
